import axios from "axios";
import { toast } from "react-hot-toast";
import { getApi } from "../backend";

export const getAllMainCategories = () => {
  return axios
    .get(`${getApi()}/api/v1/category/getAll`)
    .then((res) => {
      console.log(res, "categories");
      if (res.data.success) {
        return res.data.data;
      } else {
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      return err.response.data;
    });
};

export const getAllSubCategories = (id) => {
  return axios
    .get(`${getApi()}/api/v1/category/get/${id}`)
    .then((res) => {
      console.log(res, "subcats");
      if (res.data.success) {
        return res.data.data;
      } else {
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      return err.response.data;
    });
};

export const createCategory = (data) => {
  return axios
    .post(`${getApi()}/api/v1/category/create`, data)
    .then((res) => {
      console.log(res, "create");
      if (res.data.success) {
        toast.success(res.data.message);
        return res.data.data;
      } else {
        toast.error(res.data.message || "Something went wrong");
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error(err.response.data.message);
      return err.response.data;
    });
};

export const deleteCategory = (id) => {
  return axios
    .delete(`${getApi()}/api/v1/category/deleteCategory/${id}`)
    .then((res) => {
      console.log(res, "delete");
      if (res.data.success) {
        toast.success(res.data.data);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(res.data.message || "Something went wrong");
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error(err.response.data.message);
      return err.response.data;
    });
};

export const updateCategory = (id, data) => {
  console.log(id, data, "update");
  return axios
    .put(`${getApi()}/api/v1/category/update/${id}`, data)
    .then((res) => {
      console.log(res, "update response");
      if (res.data.success) {
        toast.success(res.data.data);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(res.data.message || "Something went wrong");
        return res.data;
      }
    })
    .catch((err) => {
      console.log(err);
      toast.error(err.response.data.message);
      return err.response.data;
    });
};
